import { render, staticRenderFns } from "./table-sort-actions.vue?vue&type=template&id=7b9fda84&"
import script from "./table-sort-actions.vue?vue&type=script&lang=js&"
export * from "./table-sort-actions.vue?vue&type=script&lang=js&"
import style0 from "./table-sort-actions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports